import { detailCardCompactSecondaryLinkClassName } from "../../design/tokens.js";

export function buildGoogleMapsDirectionsUrl(address) {
  const trimmed = String(address || "").trim();
  if (!trimmed) return "";
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(trimmed)}`;
}

/** Gleicher „Route“-Button wie in Kundendaten / Service-Info (Outline-Chip). */
export default function DetailMapsRouteLink({ address, className = "" }) {
  const href = buildGoogleMapsDirectionsUrl(address);
  if (!href) return null;

  return (
    <div className="mt-3 pt-3 border-t border-default flex justify-end">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={[detailCardCompactSecondaryLinkClassName, className].filter(Boolean).join(" ")}
      >
        Route auf Google Maps öffnen
      </a>
    </div>
  );
}
